import React, { useState, useEffect} from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton'; // Import the WhatsAppButton component


import {NavComp} from './Components/NavComp/NavComp';
import FooterComp from './Components/NavComp/FooterComp';
import Sunglass from './Components/Products/sunglasses';
import Spectacles from './Components/Products/spectacles';
import Lens from './Components/Products/lens';
import ContactLens from './Components/Products/contactlens';
import Prostheticeye from './Components/Products/prostheticeye';
import Lowvision from './Components/Services/lowvision';
import EyeClinic from './Components/Services/eyeclinic';
import EyeInvestigation from './Components/Services/eyeinvestigation';
import EyeTherapeutic from './Components/Services/eyetherapeutic';
import OrthopticAssessment from './Components/Services/orthopticassessment';
import HomeService from './Components/Services/homeservice';
import CoporateProgram from './Components/Services/coporateprogram';
import Accessories from './Components/AccessoriesComp/accessories'; 
import OnlineAppointment from './Components/AppointmentComp/onlineappointment';
import CSR from './Components/CSR/csr';
import NewsAndEvents from './Components/NewsAndEvents/newsandevent';
import Cart from './Components/CartComp/cart';
import FAQs from "./Components/InfoComp/faqs";
import TermsAndConditions from "./Components/InfoComp/termsandconditions";
import PrivacyAndPolicies from "./Components/InfoComp/privacyandpolicies";
import Body from './Components/BodyComp/body';
import Payment from "./Components/PaymentComp/payment";
import Success from "./Components/PaymentComp/success";
import Cancel from "./Components/PaymentComp/cancel";
import RefundPolicy from "./Components/InfoComp/refundpolicy";
import ProductView from "./Components/PaymentComp/productview";
import LoadingScreen from "./Components/LoadingComp/LoadingScreen";
import ContactUs from "./Components/ContactComp/contactus";

import SignIn from "./Components/LoginComp/signin";
import SignUp from "./Components/LoginComp/signup";
import ForgotPassword from "./Components/LoginComp/ForgotPassword";
import PrivateRoute from "./Utils/PrivateRoute"; 
import UserProfile from "./Components/UserComp/userprofile"; 
import ViewApplication from "./Components/UserComp/viewapplication"; 
import ViewPayment from "./Components/UserComp/viewpayment"; 
import AdminPanel from "./Components/AdminComp/adminpanel"; 
import Feedback from "./Components/FeedbackComp/feedback";
import OnlineBooking from "./Components/AppointmentComp/Online-booking";
import ScrollToTop from "./ScrollComp/ScrollToTop";

// import Snow from "./Components/SnowFlake/snow";



export const App = () => {



   const [isLoading, setIsLoading] = useState(true);
  const [hasShownLoading, setHasShownLoading] = useState(false);

  useEffect(() => {
    // Check if loading screen has been shown before (using sessionStorage)
    const loadingShown = sessionStorage.getItem('loadingShown');
    
    if (loadingShown) {
      setHasShownLoading(true);
      setIsLoading(false);
      return;
    }

    // Show loading screen for 3 seconds minimum
    const timer = setTimeout(() => {
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    }, 3000);

    // Also hide when page is fully loaded
    window.addEventListener('load', () => {
      clearTimeout(timer);
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    });

    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', () => {});
    };
  }, []);





  
  return (
    <Router>
       {isLoading && !hasShownLoading && <LoadingScreen />}
      {/* Navigation Component */}
      <ScrollToTop />
      <NavComp />
      
      {/* Define Routes for different pages */}
      <Routes>
      <Route path="/" element={<Body />} />
      <Route path="/lens" element={<Lens />} />
      <Route path="/contactlens" element={<ContactLens />} />
      <Route path="/sunglasses" element={<Sunglass />} />
      <Route path="/spectacles" element={<Spectacles />} />
      <Route path="/prostheticeye" element={<Prostheticeye />} />
      <Route path="/lowvision" element={<Lowvision />} />
      <Route path="/eyeclinic" element={<EyeClinic />} />
      <Route path="/eyeinvestigation" element={<EyeInvestigation />} />
      <Route path="/eyetherapeutic" element={<EyeTherapeutic />} />
      <Route path="/homeservice" element={<HomeService />} />
      <Route path="/coporateprogram" element={<CoporateProgram />} />
      <Route path="/orthopticassessment" element={<OrthopticAssessment />} />
      <Route path="/accessories" element={<Accessories />} />
      <Route path="/onlineappointment" element={<OnlineAppointment />} />
      <Route path="/csr" element={<CSR />} />
      <Route path="/newsandevent" element={<NewsAndEvents />} />
      <Route path="/faqs" element={<FAQs />} />
      <Route path="/termsandconditions" element={<TermsAndConditions />} />
      <Route path="/privacyandpolicies" element={<PrivacyAndPolicies />} />
      <Route path="/refundpolicy" element={<RefundPolicy />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/success" element={<Success />} />
      <Route path="/cancel" element={<Cancel />} />
      <Route path="/productview" element={<ProductView />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/userprofile" element={<UserProfile />} />
      <Route path="/viewapplication" element={<ViewApplication />} />
      <Route path="/viewpayment" element={<ViewPayment />} />
      <Route path="/Online-booking" element={<OnlineBooking />} />


    <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />


      </Routes>
      
      {/* Footer Component */}
      <FooterComp />
      
      {/* WhatsApp Button is always visible */}
      <WhatsAppButton /> {/* Add WhatsApp button outside Routes */}
      <Feedback />
      {/* <Snow /> */}
    </Router>
  );
};
